var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.isEditMode ? "Cập nhật khoản thu" : "Thêm mới khoản thu",
            size: "lg",
            "cancel-text": "Hủy",
            "confirm-text": "Lưu lại",
            "confirm-loading": _vm.loading,
            "use-panel": false,
            top: "4vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            confirm: _vm.handleSubmit,
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticClass: "sk-dialog-content",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.formRules,
                "label-width": "200px",
                "label-position": "left",
              },
            },
            [
              _c(
                "div",
                { staticClass: "prf-help-entry" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "Xem toàn bộ hướng dẫn thao tác",
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-question",
                            plain: "",
                            size: "small",
                          },
                          on: { click: _vm.openGuideDialog },
                        },
                        [
                          _vm._v(
                            "\n              Hướng dẫn thao tác\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-document" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thông tin chung"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Tên, loại và mô tả khoản thu"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "name" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Tên khoản thu\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Tên hiển thị của khoản thu (ví dụ: Học phí tháng)",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Nhập tên khoản thu...",
                                  maxlength: "255",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.dataForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "name", $$v)
                                  },
                                  expression: "dataForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "category" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Loại khoản\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Chọn khoản thu hoặc khoản hoàn trả",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "sk-u-w-full",
                                  attrs: { placeholder: "Chọn loại" },
                                  on: { change: _vm.onCategoryChange },
                                  model: {
                                    value: _vm.dataForm.category,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "category", $$v)
                                    },
                                    expression: "dataForm.category",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "Khoản thu", value: "IN" },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Khoản hoàn trả",
                                      value: "OUT",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "unit" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Đơn vị tính\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Chọn đơn vị hoặc nhập mới (lưu tạm vào danh sách).",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "sk-u-w-full",
                                  attrs: {
                                    filterable: "",
                                    "allow-create": "",
                                    "default-first-option": "",
                                    placeholder: "Chọn hoặc nhập đơn vị",
                                  },
                                  model: {
                                    value: _vm.dataForm.unit,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "unit", $$v)
                                    },
                                    expression: "dataForm.unit",
                                  },
                                },
                                _vm._l(_vm.unitsList, function (u) {
                                  return _c("el-option", {
                                    key: u,
                                    attrs: { label: u, value: u },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Mô tả\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Mô tả ngắn về khoản thu, tối đa 255 ký tự",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  autosize: "",
                                  placeholder: "Nhập mô tả...",
                                  maxlength: "255",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.dataForm.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "description", $$v)
                                  },
                                  expression: "dataForm.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--success" },
                      [_c("i", { staticClass: "el-icon-money" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Tài chính"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Đơn giá, số lượng, hóa đơn điện tử và chính sách giảm giá"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "price" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Đơn giá (VNĐ)\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Đơn giá cho 1 đơn vị tinhs (VNĐ)",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("ElCurrencyInput", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  options: {
                                    locale: "vi-VN",
                                    precision: 0,
                                    autoDecimalMode: false,
                                    distractionFree: false,
                                  },
                                },
                                on: { input: _vm.calculatePreview },
                                model: {
                                  value: _vm.dataForm.price,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "price", $$v)
                                  },
                                  expression: "dataForm.price",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "quantity" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Số lượng\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Số lượng đơn vị áp dụng cho khoản (ví dụ: 1)",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "number",
                                  step: _vm.allowDecimal ? 0.01 : 1,
                                },
                                on: { input: _vm.calculatePreview },
                                model: {
                                  value: _vm.dataForm.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "quantity",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "dataForm.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Cho phép số thập phân" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  value: _vm.allowDecimal,
                                  "active-text": "Có",
                                  "inactive-text": "Không",
                                },
                                on: { change: _vm.handleAllowDecimalChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "discount" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Giảm giá\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật nếu muốn áp dụng chính sách giảm giá (theo % hoặc theo số tiền).",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onDiscountChange },
                                  model: {
                                    value: _vm.dataForm.discount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "discount", $$v)
                                    },
                                    expression: "dataForm.discount",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Không"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.discount
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "discountType" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Loại giảm giá\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Chọn loại giảm: phần trăm (%) hoặc số tiền (VNĐ).",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2351297594
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "sk-u-w-full",
                                      attrs: { placeholder: "Chọn loại" },
                                      on: { change: _vm.calculatePreview },
                                      model: {
                                        value: _vm.dataForm.discountType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "discountType",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.discountType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "Phần trăm (%)",
                                          value: "PERCENT",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Số tiền (VNĐ)",
                                          value: "MONEY",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.discount
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "discountNumber" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm.dataForm.discountType ===
                                            "PERCENT"
                                              ? _c("span", [
                                                  _vm._v("Phần trăm giảm (%)"),
                                                ])
                                              : _c("span", [
                                                  _vm._v("Số tiền giảm (VNĐ)"),
                                                ]),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Nhập giá trị muốn giảm",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2833775715
                                  ),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _vm.dataForm.discountType === "MONEY"
                                        ? [
                                            _c("ElCurrencyInput", {
                                              staticClass: "sk-u-w-full",
                                              attrs: {
                                                options: {
                                                  locale: "vi-VN",
                                                  precision: 0,
                                                  autoDecimalMode: false,
                                                  distractionFree: false,
                                                },
                                              },
                                              on: {
                                                input: _vm.calculatePreview,
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountNumber",
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("el-input-number", {
                                              directives: [
                                                {
                                                  name: "discount-percent",
                                                  rawName: "v-discount-percent",
                                                },
                                              ],
                                              staticClass: "sk-u-w-full",
                                              attrs: {
                                                min: 0,
                                                max: 100,
                                                precision: 0,
                                                "controls-position": "right",
                                              },
                                              on: {
                                                change: _vm.calculatePreview,
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountNumber",
                                              },
                                            }),
                                          ],
                                      _vm.discountAmount !== null &&
                                      _vm.discountAmount > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "prf-discount-amount ml-3",
                                            },
                                            [
                                              _vm._v(
                                                "-" +
                                                  _vm._s(
                                                    _vm.formatMoney(
                                                      _vm.discountAmount
                                                    )
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Thành tiền\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Số tiền cuối cùng sau khi tính toán",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("div", { staticClass: "prf-preview-money" }, [
                                _vm._v(
                                  _vm._s(_vm.formatMoney(_vm.previewSumMoney))
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _vm.previewSumMoney > 0
                            ? _c(
                                "el-form-item",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Số tiền bằng chữ\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Số tiền bằng chữ (tiếng Việt) của thành tiền tham khảo.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1410104356
                                  ),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "prf-money-words" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.numberToWordsVN(
                                            _vm.previewSumMoney
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                      [_c("i", { staticClass: "el-icon-date" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thời gian áp dụng"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Cấu hình tháng, khoảng thời gian hoặc số đơn vị áp dụng"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "appliedTimeType" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Kiểu thời gian\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Thời gian mà khoản được áp ",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "sk-u-w-full",
                                  attrs: { placeholder: "Chọn kiểu thời gian" },
                                  on: { change: _vm.onAppliedTimeTypeChange },
                                  model: {
                                    value: _vm.dataForm.appliedTimeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "appliedTimeType",
                                        $$v
                                      )
                                    },
                                    expression: "dataForm.appliedTimeType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "Theo tháng",
                                      value: "MONTH",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Theo khoảng ngày",
                                      value: "TIME_PERIOD",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.appliedTimeType === "MONTH"
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Tháng áp dụng\n                  "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      "Chọn các tháng trong năm mà khoản thu này được áp dụng.",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question prf-help-icon ml-2",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3230561674
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "prf-month-grid" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              display: "flex",
                                              "justify-content": "flex-end",
                                              "margin-bottom": "6px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                model: {
                                                  value: _vm.monthsAll,
                                                  callback: function ($$v) {
                                                    _vm.monthsAll = $$v
                                                  },
                                                  expression: "monthsAll",
                                                },
                                              },
                                              [_vm._v("Chọn tất cả")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._l(_vm.monthList, function (m) {
                                          return _c("el-checkbox", {
                                            key: m.key,
                                            staticClass: "prf-month-cb",
                                            attrs: {
                                              label: m.label,
                                              border: "",
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.dataForm[m.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.dataForm,
                                                  m.key,
                                                  $$v
                                                )
                                              },
                                              expression: "dataForm[m.key]",
                                            },
                                          })
                                        }),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.dataForm.appliedTimeType === "TIME_PERIOD"
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "startDate",
                                      label: "Ngày bắt đầu",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        type: "date",
                                        placeholder: "Chọn ngày bắt đầu",
                                        "value-format": "yyyy-MM-dd",
                                      },
                                      model: {
                                        value: _vm.dataForm.startDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "startDate",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.startDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "endDate",
                                      label: "Ngày kết thúc",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        type: "date",
                                        placeholder: "Chọn ngày kết thúc",
                                        "value-format": "yyyy-MM-dd",
                                      },
                                      model: {
                                        value: _vm.dataForm.endDate,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.dataForm, "endDate", $$v)
                                        },
                                        expression: "dataForm.endDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--danger" },
                      [_c("i", { staticClass: "el-icon-user" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Cấu hình điểm danh"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Thiết lập tính phí theo điểm danh thực tế"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "attendance" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Áp dụng điểm danh\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật nếu khoản thu tính dựa trên điểm danh thực tế.",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question prf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onAttendanceChange },
                                  model: {
                                    value: _vm.dataForm.attendance,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "attendance", $$v)
                                    },
                                    expression: "dataForm.attendance",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Không"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.attendance
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "calculationMethod" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Phương pháp tính\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Tính trước: tính theo lịch học. Tính sau: tính theo điểm danh thực tế.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2503284667
                                  ),
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.dataForm.category === "OUT",
                                      },
                                      on: { change: _vm.resetAttendanceMethod },
                                      model: {
                                        value: _vm.dataForm.calculationMethod,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "calculationMethod",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataForm.calculationMethod",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            label: "BEFORE",
                                            disabled:
                                              _vm.dataForm.category === "OUT",
                                          },
                                        },
                                        [_vm._v("Tính trước")]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "AFTER" } },
                                        [_vm._v("Tính sau")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.attendanceTypeCurrentList.length > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "attendanceType" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Loại điểm danh\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Chọn loại điểm danh tương ứng với phương pháp tính.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1483073062
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        placeholder: "Chọn loại điểm danh",
                                      },
                                      on: {
                                        change: _vm.changeAttendanceTypeMethod,
                                      },
                                      model: {
                                        value: _vm.dataForm.attendanceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "attendanceType",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.attendanceType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.attendanceTypeCurrentList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            value: item.key,
                                            label: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.configKeyCurrentList.length > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "configKey" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Chi tiết\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Chọn chi tiết tương ứng với loại điểm danh.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1088570638
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "sk-u-w-full",
                                      attrs: { placeholder: "Chọn chi tiết" },
                                      model: {
                                        value: _vm.dataForm.configKey,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "configKey",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.configKey",
                                      },
                                    },
                                    _vm._l(
                                      _vm.configKeyCurrentList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            value: item.key,
                                            label: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.dataForm.category === "IN" &&
                      _vm.dataForm.calculationMethod === "AFTER" &&
                      _vm.dataForm.attendanceType === "LATE"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Giờ đón về\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Thời gian đón về chuẩn (HH:mm), dùng để xác định khung đón muộn.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    225236344
                                  ),
                                },
                                [
                                  _c("el-time-picker", {
                                    staticClass: "sk-u-w-full",
                                    attrs: {
                                      format: "HH:mm",
                                      "picker-options": { format: "HH:mm" },
                                      "value-format": "HH:mm",
                                      placeholder: "Chọn giờ đón về",
                                    },
                                    model: {
                                      value: _vm.dataForm.configTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataForm,
                                          "configTime",
                                          $$v
                                        )
                                      },
                                      expression: "dataForm.configTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.dataForm.category === "IN" &&
                      _vm.dataForm.calculationMethod === "AFTER" &&
                      _vm.dataForm.attendanceType === "LATE"
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Cấu hình đón muộn\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Mỗi block tương ứng 1 khoảng thời gian đón muộn và mức thu tiền tương ứng.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question prf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    25051951
                                  ),
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "prf-config-header mb-1",
                                      attrs: { gutter: 10 },
                                    },
                                    [
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "prf-col-label" },
                                          [_vm._v("Tên block")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "prf-col-label" },
                                          [_vm._v("Từ giờ")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "prf-col-label" },
                                          [_vm._v("Đến giờ")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 5 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "prf-col-label" },
                                          [_vm._v("Số tiền (VNĐ)")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 1 } }),
                                    ],
                                    1
                                  ),
                                  _vm.dataForm.configList.length === 0
                                    ? _c(
                                        "div",
                                        { staticClass: "prf-empty-config" },
                                        [
                                          _vm._v(
                                            'Chưa có cấu hình. Nhấn "+ Thêm" để bắt đầu.'
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._l(
                                    _vm.dataForm.configList,
                                    function (cfg, idx) {
                                      return _c(
                                        "div",
                                        {
                                          key: idx,
                                          staticClass: "prf-config-row mb-2",
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              attrs: {
                                                gutter: 10,
                                                align: "middle",
                                                type: "flex",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "Tên (vd: Muộn 30 phút)",
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value: cfg.configName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c("el-time-picker", {
                                                    staticClass: "sk-u-w-full",
                                                    attrs: {
                                                      format: "HH:mm",
                                                      "picker-options": {
                                                        format: "HH:mm",
                                                      },
                                                      "value-format": "HH:mm",
                                                      placeholder: "Từ giờ",
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value:
                                                        cfg.configStartTime,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configStartTime",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configStartTime",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c("el-time-picker", {
                                                    staticClass: "sk-u-w-full",
                                                    attrs: {
                                                      format: "HH:mm",
                                                      "picker-options": {
                                                        format: "HH:mm",
                                                      },
                                                      "value-format": "HH:mm",
                                                      placeholder: "Đến giờ",
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value: cfg.configEndTime,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configEndTime",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configEndTime",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 5 } },
                                                [
                                                  _c("ElCurrencyInput", {
                                                    staticClass: "sk-u-w-full",
                                                    attrs: {
                                                      options: {
                                                        locale: "vi-VN",
                                                        precision: 0,
                                                        autoDecimalMode: false,
                                                        distractionFree: false,
                                                      },
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value: cfg.configValue,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configValue",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configValue",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                {
                                                  staticClass: "text-right",
                                                  attrs: { span: 1 },
                                                },
                                                [
                                                  _c("el-button", {
                                                    attrs: {
                                                      type: "danger",
                                                      icon: "el-icon-delete",
                                                      size: "mini",
                                                      circle: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeConfig(
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        icon: "el-icon-plus",
                                        plain: "",
                                      },
                                      on: { click: _vm.addConfig },
                                    },
                                    [_vm._v("Thêm khoảng thời gian")]
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isEditMode
                ? _c(
                    "div",
                    { staticClass: "sk-panel mt-4" },
                    [
                      _c("div", { staticClass: "sk-panel-head" }, [
                        _c(
                          "div",
                          {
                            staticClass: "sk-panel-icon sk-panel-icon--danger",
                          },
                          [_c("i", { staticClass: "el-icon-warning-outline" })]
                        ),
                        _c("div", [
                          _c("p", { staticClass: "sk-panel-title" }, [
                            _vm._v("Áp dụng cho học sinh đã đăng ký"),
                          ]),
                          _c("p", { staticClass: "sk-panel-subtitle" }, [
                            _vm._v(
                              "Ghi đè giá mới xuống tất cả học sinh đã đăng ký cho khoản phụ này"
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "prf-override-checkbox",
                                      model: {
                                        value: _vm.updateRegisteredOverride,
                                        callback: function ($$v) {
                                          _vm.updateRegisteredOverride = $$v
                                        },
                                        expression: "updateRegisteredOverride",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Áp dụng thay đổi cho HS đã đăng ký\n              "
                                      ),
                                    ]
                                  ),
                                  _vm.updateRegisteredOverride
                                    ? _c(
                                        "div",
                                        { staticClass: "prf-override-warning" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-warning",
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              "\n                  Lưu ý: Giá trị riêng đã sửa cho từng HS sẽ bị ghi đè bằng giá mới.\n                  Hành động này không thể hoàn tác.\n                "
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c("principal-revenue-guide-dialog", { ref: "guideDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }